export default () => {
  return <div className="calendar-calendar-horas-menu-semana-separador" />;
};
